import BottomNav from './BottomNav';
import Sidebar from './Sidebar';
import MobileHeader from './MobileHeader';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black">
      <Sidebar />
      <MobileHeader />
      <BottomNav />
      <main className="md:ml-64 pb-20 md:pb-0">
        {children}
      </main>
    </div>
  );
}
